module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/5ece8908fef739d9448eb27b957f463e.png";